import { createSlice } from '@reduxjs/toolkit';

// Get token and user from localStorage if they exist (survives tab switches & reloads)
const token = localStorage.getItem('auth_token') || null;
const userStr = localStorage.getItem('auth_user');
let user = null;

try {
  if (userStr) {
    user = JSON.parse(userStr);
  }
} catch (e) {
  // Clear if invalid
  localStorage.removeItem('auth_user');
}

const initialState = {
  token: token,
  user: user,
  isAuthenticated: !!token,
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      const { user, token } = action.payload;
      state.user = user;
      state.token = token;
      state.isAuthenticated = true;
      // Persist to localStorage so it works across tabs
      localStorage.setItem('auth_token', token);
      localStorage.setItem('auth_user', JSON.stringify(user));
    },
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      // Clear from localStorage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
